module.exports = __webpack_public_path__ + "static/image-corp-80f8012fcc90e48a08c634d123c187e0.jpg";